import React, { useState } from 'react';

const Counter = () => {
  const [value, setValue] = useState(0);

  return (
    <div className="counter">
      <div className="counter-value">{value}</div>
      <div className="counter-actions">
        <button className="btn small" onClick={() => setValue((v) => v - 1)}>
          -1
        </button>
        <button className="btn small" onClick={() => setValue(0)}>
          Reset
        </button>
        <button className="btn small" onClick={() => setValue((v) => v + 1)}>
          +1
        </button>
      </div>
    </div>
  );
};

export default Counter;
